import React, { useState } from "react";
import {
    Card,
    CardBody,
    Nav,
    NavItem,
    NavLink,
    Table,
    Badge,
    Button
} from "reactstrap";
import classnames from "classnames";
import moment from "moment";
import { Link } from "react-router-dom";
import AuditTrailModal from "modules/Approvals/components/AuditTrailModal";

const EmployeeRecentEntries = ({ recentOrders, recentProcess, recentApprovals, onViewOrder, onEditOrder }) => {
    const [activeTab, setActiveTab] = useState("orders");
    const [selectedAuditDoc, setSelectedAuditDoc] = useState(null);

    const getStatusBadge = (status) => {
        switch (status) {
            case "approved":
                return (
                    <span
                        style={{
                            background: "#dcfce7",
                            color: "#166534",
                            border: "1px solid #86efac",
                            padding: "4px 12px",
                            borderRadius: "20px",
                            fontSize: "12px",
                            fontWeight: "700",
                            display: "inline-flex",
                            alignItems: "center"
                        }}
                    >
                        <i className="bx bx-check-circle me-1"></i> Approved
                    </span>
                );
            case "rejected":
                return (
                    <span
                        style={{
                            background: "#fee2e2",
                            color: "#991b1b",
                            border: "1px solid #fca5a5",
                            padding: "4px 12px",
                            borderRadius: "20px",
                            fontSize: "12px",
                            fontWeight: "700",
                            display: "inline-flex",
                            alignItems: "center"
                        }}
                    >
                        <i className="bx bx-x-circle me-1"></i> Rejected
                    </span>
                );
            case "used":
                return (
                    <span
                        style={{
                            background: "#e0f2fe",
                            color: "#0369a1",
                            border: "1px solid #bae6fd",
                            padding: "4px 12px",
                            borderRadius: "20px",
                            fontSize: "12px",
                            fontWeight: "700",
                            display: "inline-flex",
                            alignItems: "center"
                        }}
                    >
                        <i className="bx bx-check-double me-1"></i> Edit Saved
                    </span>
                );
            case "pending":
            default:
                return (
                    <span
                        style={{
                            background: "#fef3c7",
                            color: "#92400e",
                            border: "1px solid #fcd34d",
                            padding: "4px 12px",
                            borderRadius: "20px",
                            fontSize: "12px",
                            fontWeight: "700",
                            display: "inline-flex",
                            alignItems: "center"
                        }}
                    >
                        <i className="bx bx-time-five me-1"></i> Pending Review
                    </span>
                );
        }
    };

    const getOrderEditConfig = (order) => {
        let status = order?.approval_status;

        if (!status && recentApprovals && recentApprovals.length > 0) {
            const found = recentApprovals.find(a =>
                a.document_type === "order" &&
                (String(a.document_id) === String(order.id) ||
                 String(a.document_number) === String(order.order_number) ||
                 String(a.document_id) === String(order.order_number))
            );
            if (found) {
                status = found.status;
            }
        }

        if (status === "approved") {
            return {
                style: {
                    background: "#dcfce7",
                    color: "#15803d",
                    border: "1px solid #86efac",
                    fontWeight: "600",
                    padding: "5px 12px",
                    borderRadius: "6px",
                    fontSize: "12px",
                    display: "inline-flex",
                    alignItems: "center"
                },
                icon: "bx bx-edit-alt",
                title: "Edit Authorized (Click to Edit)",
                label: "Edit"
            };
        } else if (status === "pending") {
            return {
                style: {
                    background: "#fef3c7",
                    color: "#b45309",
                    border: "1px solid #fcd34d",
                    fontWeight: "600",
                    padding: "5px 12px",
                    borderRadius: "6px",
                    fontSize: "12px",
                    display: "inline-flex",
                    alignItems: "center"
                },
                icon: "bx bx-time-five",
                title: "Approval Requested (Pending Admin Review)",
                label: "Pending"
            };
        } else {
            return {
                style: {
                    background: "#fee2e2",
                    color: "#b91c1c",
                    border: "1px solid #fca5a5",
                    fontWeight: "600",
                    padding: "5px 12px",
                    borderRadius: "6px",
                    fontSize: "12px",
                    display: "inline-flex",
                    alignItems: "center"
                },
                icon: "bx bx-lock-alt",
                title: "Edit Authorization Required (Click to Request)",
                label: "Edit"
            };
        }
    };

    return (
        <>
            <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
                <CardBody className="p-4">
                    <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
                        <Nav tabs className="border-0">
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === "orders" })}
                                    onClick={() => setActiveTab("orders")}
                                    style={{
                                        cursor: "pointer",
                                        fontWeight: activeTab === "orders" ? "700" : "500",
                                        borderBottom: activeTab === "orders" ? "2px solid #556ee6" : "none"
                                    }}
                                >
                                    <i className="mdi mdi-clipboard-list-outline me-1 text-primary"></i>
                                    My Recent Orders ({recentOrders?.length || 0})
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === "process" })}
                                    onClick={() => setActiveTab("process")}
                                    style={{
                                        cursor: "pointer",
                                        fontWeight: activeTab === "process" ? "700" : "500",
                                        borderBottom: activeTab === "process" ? "2px solid #556ee6" : "none"
                                    }}
                                >
                                    <i className="mdi mdi-tray-full me-1 text-info"></i>
                                    Process Scans & Movement ({recentProcess?.length || 0})
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === "approvals" })}
                                    onClick={() => setActiveTab("approvals")}
                                    style={{
                                        cursor: "pointer",
                                        fontWeight: activeTab === "approvals" ? "700" : "500",
                                        borderBottom: activeTab === "approvals" ? "2px solid #556ee6" : "none"
                                    }}
                                >
                                    <i className="mdi mdi-shield-check-outline me-1 text-warning"></i>
                                    Edit Approval Requests ({recentApprovals?.length || 0})
                                </NavLink>
                            </NavItem>
                        </Nav>

                        <div className="mt-2 mt-sm-0">
                            {activeTab === "orders" && (
                                <Link to="/orders" className="btn btn-outline-primary btn-sm fw-semibold">
                                    View All Orders <i className="mdi mdi-arrow-right ms-1"></i>
                                </Link>
                            )}
                            {activeTab === "process" && (
                                <Link to="/process" className="btn btn-outline-info btn-sm fw-semibold">
                                    Process Dashboard <i className="mdi mdi-arrow-right ms-1"></i>
                                </Link>
                            )}
                        </div>
                    </div>

                    {/* Tab 1: Recent Orders */}
                    {activeTab === "orders" && (
                        recentOrders && recentOrders.length > 0 ? (
                            <div className="table-responsive">
                                <Table className="align-middle table-hover mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Order #</th>
                                            <th>Patient Name</th>
                                            <th>Client / Doctor</th>
                                            <th>Units</th>
                                            <th>In Date</th>
                                            <th>Due Date</th>
                                            <th>Work Type</th>
                                            <th className="text-end">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {recentOrders.map((order) => (
                                            <tr key={order.id}>
                                                <td>
                                                    <span style={{ color: "#2563eb", fontWeight: "700", fontSize: "13px" }}>#{order.order_number}</span>
                                                    {order.case_no && (
                                                        <span style={{ color: "#475569", display: "block", fontSize: "11px", fontWeight: "600" }}>Case: {order.case_no}</span>
                                                    )}
                                                </td>
                                                <td>
                                                    <div style={{ color: "#0f172a", fontWeight: "700", fontSize: "13px" }}>{order.patient_name || "--"}</div>
                                                    {order.patient_age && <span style={{ color: "#64748b", fontSize: "11px", fontWeight: "500" }}>Age: {order.patient_age}</span>}
                                                </td>
                                                <td>
                                                    <div className="text-truncate" style={{ maxWidth: "200px", color: "#1e293b", fontWeight: "600", fontSize: "13px" }}>
                                                        {order.clientname || "--"}
                                                    </div>
                                                </td>
                                                <td>
                                                    <span
                                                        style={{
                                                            background: "#eff6ff",
                                                            color: "#1d4ed8",
                                                            border: "1px solid #bfdbfe",
                                                            padding: "3px 10px",
                                                            borderRadius: "6px",
                                                            fontSize: "12px",
                                                            fontWeight: "700",
                                                            display: "inline-block"
                                                        }}
                                                    >
                                                        {order.units || 1} Units
                                                    </span>
                                                </td>
                                                <td>
                                                    <span style={{ color: "#334155", fontSize: "12px", fontWeight: "600" }}>
                                                        {moment(order.in_date).format("DD MMM YYYY")}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span style={{
                                                        color: moment(order.due_date).isSame(moment(), "day") ? "#dc2626" : "#334155",
                                                        fontWeight: moment(order.due_date).isSame(moment(), "day") ? "800" : "600",
                                                        fontSize: "12px"
                                                    }}>
                                                        {order.due_date ? moment(order.due_date).format("DD MMM YYYY") : "--"}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span
                                                        style={{
                                                            background: "#f1f5f9",
                                                            color: "#334155",
                                                            border: "1px solid #cbd5e1",
                                                            padding: "3px 8px",
                                                            borderRadius: "6px",
                                                            fontSize: "11px",
                                                            fontWeight: "700",
                                                            textTransform: "uppercase"
                                                        }}
                                                    >
                                                        {order.worktype || "NEW"}
                                                    </span>
                                                </td>
                                                <td className="text-end" style={{ whiteSpace: "nowrap" }}>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm me-2"
                                                        style={{
                                                            background: "#f1f5f9",
                                                            color: "#334155",
                                                            border: "1px solid #cbd5e1",
                                                            fontWeight: "600",
                                                            padding: "5px 12px",
                                                            borderRadius: "6px",
                                                            fontSize: "12px",
                                                            display: "inline-flex",
                                                            alignItems: "center"
                                                        }}
                                                        onClick={() => {
                                                            if (onViewOrder) {
                                                                onViewOrder(order);
                                                            } else {
                                                                window.location.href = `/orders`;
                                                            }
                                                        }}
                                                        title="View Order Details"
                                                    >
                                                        <i className="bx bx-show-alt me-1 font-size-14 align-middle"></i> View
                                                    </button>
                                                    {(() => {
                                                        const editCfg = getOrderEditConfig(order);
                                                        return (
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm"
                                                                style={editCfg.style}
                                                                onClick={() => {
                                                                    if (onEditOrder) {
                                                                        onEditOrder(order);
                                                                    } else if (onViewOrder) {
                                                                        onViewOrder(order);
                                                                    } else {
                                                                        window.location.href = `/orders`;
                                                                    }
                                                                }}
                                                                title={editCfg.title}
                                                            >
                                                                <i className={`${editCfg.icon} me-1 font-size-14 align-middle`}></i> {editCfg.label}
                                                            </button>
                                                        );
                                                    })()}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        ) : (
                            <div className="text-center py-5 text-muted">
                                <i className="mdi mdi-clipboard-outline font-size-36 d-block mb-2 text-secondary"></i>
                                No recent orders found.
                            </div>
                        )
                    )}

                    {/* Tab 2: Process Movement */}
                    {activeTab === "process" && (
                        recentProcess && recentProcess.length > 0 ? (
                            <div className="table-responsive">
                                <Table className="align-middle table-hover mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Timestamp</th>
                                            <th>Order #</th>
                                            <th>Department</th>
                                            <th>Status</th>
                                            <th>Action / Note</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {recentProcess.map((proc) => (
                                            <tr key={proc.id}>
                                                <td>
                                                    <span style={{ color: "#334155", fontSize: "12px", fontWeight: "600" }}>
                                                        {moment(proc.timestamp).format("DD MMM, hh:mm A")}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span style={{ color: "#2563eb", fontWeight: "700", fontSize: "13px" }}>#{proc.order_number}</span>
                                                </td>
                                                <td>
                                                    <span style={{ color: "#0f172a", fontWeight: "600", fontSize: "13px" }}>{proc.department_name || "--"}</span>
                                                </td>
                                                <td>
                                                    <span
                                                        style={{
                                                            background: "#f0fdfa",
                                                            color: "#0f766e",
                                                            border: "1px solid #99f6e4",
                                                            padding: "3px 10px",
                                                            borderRadius: "6px",
                                                            fontSize: "11px",
                                                            fontWeight: "700"
                                                        }}
                                                    >
                                                        {proc.action_type || "SCAN"}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span style={{ color: "#475569", fontSize: "12px", fontWeight: "500" }}>{proc.notes || "Movement recorded"}</span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        ) : (
                            <div className="text-center py-5 text-muted">
                                <i className="mdi mdi-tray-remove font-size-36 d-block mb-2 text-secondary"></i>
                                No recent process activity found.
                            </div>
                        )
                    )}

                    {/* Tab 3: Approval Requests */}
                    {activeTab === "approvals" && (
                        recentApprovals && recentApprovals.length > 0 ? (
                            <div className="table-responsive">
                                <Table className="align-middle table-hover mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Doc Type</th>
                                            <th>Document #</th>
                                            <th>Requested Date</th>
                                            <th style={{ width: "35%" }}>Reason</th>
                                            <th>Status</th>
                                            <th className="text-end">Audit</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {recentApprovals.map((item) => (
                                            <tr key={item.id}>
                                                <td>
                                                    <span
                                                        style={{
                                                            background: item.document_type === "order" ? "#e0e7ff" : "#f1f5f9",
                                                            color: item.document_type === "order" ? "#3730a3" : "#334155",
                                                            border: `1px solid ${item.document_type === "order" ? "#c7d2fe" : "#cbd5e1"}`,
                                                            padding: "3px 8px",
                                                            borderRadius: "6px",
                                                            fontSize: "11px",
                                                            fontWeight: "700",
                                                            letterSpacing: "0.5px"
                                                        }}
                                                    >
                                                        {item.document_type?.toUpperCase()}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span style={{ color: "#0f172a", fontWeight: "700", fontSize: "13px" }}>
                                                        #{item.document_number || item.document_id}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span style={{ color: "#334155", fontWeight: "600", fontSize: "12px" }}>
                                                        {moment(item.requested_at).format("DD MMM YYYY, hh:mm A")}
                                                    </span>
                                                </td>
                                                <td>
                                                    <div style={{ maxWidth: "320px", whiteSpace: "normal", fontSize: "13px", color: "#0f172a", fontWeight: "600" }}>
                                                        {item.reason}
                                                    </div>
                                                    {item.rejection_reason && (
                                                        <div style={{ color: "#b91c1c", fontSize: "12px", marginTop: "4px", fontWeight: "600" }}>
                                                            <strong>Rejection:</strong> {item.rejection_reason}
                                                        </div>
                                                    )}
                                                    {item.approved_by_name && (
                                                        <div style={{ color: "#15803d", fontSize: "12px", marginTop: "4px", fontWeight: "600" }}>
                                                            Approved by {item.approved_by_name}
                                                        </div>
                                                    )}
                                                </td>
                                                <td>{getStatusBadge(item.status)}</td>
                                                <td className="text-end" style={{ whiteSpace: "nowrap" }}>
                                                    {item.status === "approved" && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm me-2"
                                                            style={{
                                                                background: "#dcfce7",
                                                                color: "#15803d",
                                                                border: "1px solid #86efac",
                                                                fontWeight: "600",
                                                                padding: "5px 12px",
                                                                borderRadius: "6px",
                                                                fontSize: "12px",
                                                                display: "inline-flex",
                                                                alignItems: "center"
                                                            }}
                                                            onClick={() => {
                                                                if (onEditOrder) {
                                                                    onEditOrder(item);
                                                                } else if (onViewOrder) {
                                                                    onViewOrder(item);
                                                                }
                                                            }}
                                                            title="Edit Approved Order"
                                                        >
                                                            <i className="bx bx-edit-alt me-1 font-size-14 align-middle"></i> Edit
                                                        </button>
                                                    )}
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm"
                                                        style={{
                                                            background: "#e0f2fe",
                                                            color: "#0369a1",
                                                            border: "1px solid #bae6fd",
                                                            fontWeight: "600",
                                                            padding: "5px 12px",
                                                            borderRadius: "6px",
                                                            fontSize: "12px",
                                                            display: "inline-flex",
                                                            alignItems: "center"
                                                        }}
                                                        onClick={() => setSelectedAuditDoc(item)}
                                                        title="View History & Diff"
                                                    >
                                                        <i className="bx bx-history me-1 font-size-14 align-middle"></i> Audit
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        ) : (
                            <div className="text-center py-5 text-muted">
                                <i className="mdi mdi-shield-outline font-size-36 d-block mb-2 text-secondary"></i>
                                No edit requests submitted yet.
                            </div>
                        )
                    )}
                </CardBody>
            </Card>

            {/* Audit Trail Modal */}
            {selectedAuditDoc && (
                <AuditTrailModal
                    isOpen={Boolean(selectedAuditDoc)}
                    toggle={() => setSelectedAuditDoc(null)}
                    documentType={selectedAuditDoc.document_type}
                    documentId={selectedAuditDoc.document_id}
                    documentNumber={selectedAuditDoc.document_number}
                />
            )}
        </>
    );
};

export default EmployeeRecentEntries;
